<script>
import Newsfeed from "../../common/components/Newsfeed.vue";

export default {
  components: {
    Newsfeed,
  },

  methods: {
    goToUrl: (event) => {
      if (event) {
        let target = event.target;

        // If target is not the element where the event is defined, retrieve it
        if (!event.target.classList.contains("tank-collection__products")) {
          target = target.closest(".tank-collection__products");
        }

        // Then retrieve the URL and redirect to it
        const to = "href" in target.dataset ? target.dataset.href : "";
        window.location = to;
      }
    },
  },
};
</script>

<style lang="sass">
@import ../../common/styles/settings
@import ../../common/styles/mixins

.tank-collection
    &__overview
        padding-bottom: $baseline
        margin-top: 25px
        +media('<medium')
            margin-top: 0

        +media('>xsmall')
            padding-bottom: $baseline*2

        .card
            height: 100%

            &__body
                display: flex
                flex-direction: column
                justify-content: flex-start
                height: 100%

        .list
            margin-top: auto
            margin-bottom: 0

            li
                margin-bottom: 0

        .text
            margin-bottom: 2.75rem


    &__products
        color: inherit
        text-decoration: none
        cursor: pointer

        +media(">xsmall")
            margin-bottom: $baseline

        & + &
            +media("<=xsmall")
                margin-top: $baseline

    &__informations
        margin-bottom: $baseline*2
    &__upkeep
        margin-bottom: $baseline*22

        +media('>xsmall')
            margin-bottom: $baseline*32

        +media('>small')
            margin-bottom:  $baseline*6

        &.section
            +media('<=small')
                padding-top: $baseline*8

        &__link
            +media('<small')
                text-align: center

        &__pop
            margin-bottom: $baseline*-24
            +media('>small')
                margin-bottom: $baseline*-8

            .link
                position: relative
                +media('>=small')
                    top: $baseline*.25
                    margin-top: $baseline


    .card--tip
        svg
            +media('<=xsmall')
                margin-right: 0
                height: $baseline*3
                width: $baseline*3
    .card--custom
        h3
            font-size: 1.25rem

    .section-network
        .card--inline
            background-image: none
    @media(min-width: 481px)
      .section .title+.subtitle
          margin-top:0!important
</style>
